import { createFileRoute, Link } from "@tanstack/react-router";
import { Card } from "../../components/Card";
import { useI18n } from "../../lib/i18n";
import { useSession } from "../../lib/session";

function AppHome() {
  const { t } = useI18n();
  const s = useSession();
  if (s.state !== "signed") return null;
  return (
    <div className="mx-auto max-w-6xl px-4 sm:px-6 py-8 sm:py-12 flex flex-col gap-6">
      <div className="flex flex-col gap-2">
        <span className="eyebrow">{t("app.title")}</span>
        <h1 className="font-display text-3xl sm:text-4xl font-semibold">
          {t("app.welcome", { name: s.me.user.display_name })}
        </h1>
      </div>

      <Card>
        <p className="text-secondary">{t("app.placeholder")}</p>
      </Card>

      {/* Panel cards — Brand Studio is live; the rest light up as their
          backend services ship. */}
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        <PanelLive
          eyebrow="MARKALAR · BRANDS"
          title="Brand Studio"
          to="/app/brands"
        />
        <PanelLive
          eyebrow="İÇERİK · CONTENT"
          title="Content Studio"
          to="/app/content"
        />
        <PanelLive
          eyebrow="YORUMLAR · COMMENTS"
          title="Inbox"
          to="/app/comments"
        />
        <PanelStub eyebrow="ANALİZ · ANALYTICS" title="Performance" />
        <PanelStub eyebrow="FATURALAMA · BILLING" title="Plan & Credits" />
        <PanelStub eyebrow="EKİP · TEAM" title="Members" />
      </div>
    </div>
  );
}

function PanelLive({ eyebrow, title, to }: { eyebrow: string; title: string; to: string }) {
  return (
    <Link to={to} className="ring-nexus rounded-[14px]">
      <Card className="!p-5 hover:bg-overlay/40 transition h-full">
        <span className="eyebrow">{eyebrow}</span>
        <h2 className="font-display text-lg font-semibold mt-2">{title}</h2>
        <p className="text-xs text-success mt-3">▸ open</p>
      </Card>
    </Link>
  );
}

function PanelStub({ eyebrow, title }: { eyebrow: string; title: string }) {
  return (
    <Card className="!p-5 transition cursor-not-allowed opacity-70">
      <span className="eyebrow">{eyebrow}</span>
      <h2 className="font-display text-lg font-semibold mt-2">{title}</h2>
      <p className="text-xs text-muted mt-3">soon · yakında</p>
    </Card>
  );
}

export const Route = createFileRoute("/app/")({
  component: AppHome,
});
